import DependenciesGoToTask from './DependenciesGoToTask';

export default DependenciesGoToTask;
